import moment from "moment";
import * as actionTypes from "../actions/types";

const calculatePremiumFlags = (userData) => {
  if (!userData) {
    return {
      isFreeTrialAvailable: false,
      isFreeTrialActive: false,
      isUserPremium: false,
      isGuestAccount: false,
      isSuscriptionCancelled: false,
      isCancelledSuscriptionStillActive: false,
    };
  }

  const isFreeTrialActivated = userData.free_trial?.status === "in-course";
  const isPaymentPending = userData.subscription?.status === "pending";
  const isPaymentPaid = userData.subscription?.status === "active";
  const isSuscriptionCancelled = userData.subscription?.status === "expired";
  const isUserSuscribed = isPaymentPending || isPaymentPaid;
  const isCancelledSuscriptionStillActive = isSuscriptionCancelled && moment().isBefore(userData.subscription?.end_date);
  
  return {
    isFreeTrialAvailable: userData.free_trial?.status === "no-activated",
    isFreeTrialActive: isFreeTrialActivated,
    isUserPremium: isUserSuscribed || isFreeTrialActivated || isCancelledSuscriptionStillActive,
    isGuestAccount: userData.username === "invited@edify.la",
    isSuscriptionCancelled: isSuscriptionCancelled,
    isCancelledSuscriptionStillActive: isCancelledSuscriptionStillActive,
  };
};

const INITIAL_STATE = {
  isAuth: false,
  componentLoading: false,
  error: false,
  success: false,
  recoverOpen: false,
  openMainModal: false,
  mainModalConfig: {},
  inviteToRegisterModal: false,
  workBagSuccessModal: false,
  openFeedTextModal: false,
  feedModalConfig: {},
  openNDAModal: false,
  sideNavBarExpanded: true,
  isLoaded: false,
  loginType: "",
  loginAnimation: false,
  loginAnimationType: "login",
  logoutAnimation: false,
  edifySpinner: false,
  userData: null,
  showSendContactNotificationModal: false,
  calificationModal: false,
  showSuscriptionModal: false,
  isFreeTrialAvailable: false,
  isGuestAccount: false,
  isUserPremium: false,
  usersRegisteredData: [],
  profileVisualizer: null,
};

const generalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SET_ACCESS:
      return {
        ...state,
        accessData: action.payload,
      };
    case actionTypes.OPEN_SEND_CONTACT_NOTIFICATION_MODAL:
      return {
        ...state,
        showSendContactNotificationModal: action.payload,
      };
    case actionTypes.CLOSE_SEND_CONTACT_NOTIFICATION_MODAL:
      return {
        ...state,
        showSendContactNotificationModal: false,
      };
    case actionTypes.OPEN_CALIFICATION_MODAL:
      return {
        ...state,
        calificationModal: action.payload,
      };
    case actionTypes.CLOSE_CALIFICATION_MODAL:
      return {
        ...state,
        calificationModal: false,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        isAuth: true,
      };

    case actionTypes.GET_DATA:
      const premiumFlags = calculatePremiumFlags(action.payload);
      return {
        ...state,
        userData: action.payload,
        ...premiumFlags,
      };
    case actionTypes.SET_USER_SKILLS:
      return {
        ...state,
        userData: {
          ...state.userData,
          userskills: action.payload,
        },
      };
    case actionTypes.MY_DATA:
      const myDataPremiumFlags = calculatePremiumFlags(action.payload);
      return {
        ...state,
        userData: action.payload,
        ...myDataPremiumFlags,
      };
    case actionTypes.RECOVERY_START:
      return {
        ...state,
        success: false,
      };
    case actionTypes.RECOVERY_FAIL:
      return {
        ...state,
        error: true,
      };
    case actionTypes.RECOVERY_SUCCESS:
      return {
        ...state,
        success: true,
        recoverOpen: false,
        error: false,
      };
    case actionTypes.CLOSE_MODAL:
      return {
        ...state,
        recoverOpen: false,
        success: false,
      };
    case actionTypes.SET_SUCCESS:
      return {
        ...state,
        success: true,
      };
    case actionTypes.SET_NEW_PROFILE_IMAGE:
      return {
        ...state,
        success: false,
      };
    case actionTypes.SET_PROFILE_VISUALIZER:
      return {
        ...state,
        profileVisualizer: action.payload,
        commentPosted: false,
      };
    case actionTypes.COMMENT_POSTED:
      return {
        ...state,
        commentPosted: action.payload,
      };
    case actionTypes.SET_SKILLS:
      return {
        ...state,
        isAuth: true,
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        isAuth: false,
        userData: null,
        isUserPremium: false,
        isFreeTrialAvailable: false,
        isFreeTrialActive: false,
        isSuscriptionCancelled: false,
        isCancelledSuscriptionStillActive: false,
      };
    case actionTypes.EXPANDED_SIDEBAR:
      return {
        ...state,
        sideNavBarExpanded: action.payload,
      };
    case actionTypes.SKELETON_START:
      return {
        ...state,
        isLoaded: false,
      };
    case actionTypes.SKELETON_END:
      return {
        ...state,
        isLoaded: true,
      };
    case actionTypes.LOGIN_TYPE:
      return {
        ...state,
        loginType: action.payload,
      };
    case actionTypes.SET_LOGIN_ANIMATION:
      return {
        ...state,
        loginAnimation: action.payload,
      };
    case actionTypes.SET_LOGIN_ANIMATION_TYPE:
      return {
        ...state,
        loginAnimationType: action.payload,
      };
    case actionTypes.SET_LOGOUT_ANIMATION:
      return {
        ...state,
        logoutAnimation: action.payload,
      };
    case actionTypes.OPEN_EDIFY_SPINNER:
      return {
        ...state,
        edifySpinner: action.payload,
      };
    case actionTypes.CLOSE_EDIFY_SPINNER:
      return {
        ...state,
        edifySpinner: false,
      };
    case actionTypes.START_LOADING:
      return {
        ...state,
        componentLoading: true,
      };
    case actionTypes.END_LOADING:
      return {
        ...state,
        componentLoading: false,
      };
    case actionTypes.OPEN_MAIN_MODAL: {
      return {
        ...state,
        openMainModal: true,
        mainModalConfig: { ...action.payload },
      };
    }
    case actionTypes.OPEN_FEED_TEXT_MODAL: {
      return {
        ...state,
        openFeedTextModal: true,
        feedModalConfig: { ...action.payload },
      };
    }
    case actionTypes.CLOSE_MAIN_MODAL: {
      return {
        ...state,
        openMainModal: false,
        mainModalConfig: { ...INITIAL_STATE.mainModalConfig },
      };
    }
    case actionTypes.OPEN_INVITE_TO_REGISTER_MODAL:
      return {
        ...state,
        inviteToRegisterModal: {
          open: true,
          context: action.payload || "after_identity_photos",
        },
      };
    case actionTypes.CLOSE_INVITE_TO_REGISTER_MODAL:
      return {
        ...state,
        inviteToRegisterModal: false,
      };
    case actionTypes.OPEN_WORKBAG_SUCCESS_MODAL:
      return {
        ...state,
        workBagSuccessModal: { open: true, email: action.payload },
      };
    case actionTypes.CLOSE_WORKBAG_SUCCESS_MODAL:
      return {
        ...state,
        workBagSuccessModal: false,
      };
    case actionTypes.CLOSE_FEED_TEXT_MODAL: {
      return {
        ...state,
        openFeedTextModal: false,
        feedModalConfig: { ...INITIAL_STATE.feedModalConfig },
      };
    }
    case actionTypes.OPEN_NDA_MODAL:
      return {
        ...state,
        openNDAModal: true,
      };
    case actionTypes.CLOSE_NDA_MODAL:
      return {
        ...state,
        openNDAModal: false,
      };
    case actionTypes.USERS_REGISTERED_DATA:
      return {
        ...state,
        usersRegisteredData: action.payload,
      };
    case actionTypes.OPEN_SUSCRIPTION_MODAL: {
      return {
        ...state,
        showSuscriptionModal: true,
      };
    }
    case actionTypes.CLOSE_SUSCRIPTION_MODAL: {
      return {
        ...state,
        showSuscriptionModal: false,
      };
    }
    
    default:
      return state;
  }
};

export default generalReducer;



